import * as React from 'react';
import ContextMenu from '../../components/context-menu/ContextMenu';
import { Field } from '../../components/dynamic-input-field/DynamicInputField';
import Config from '../../config/Config';
import FormEditor from '../form-editor/FormEditor';
import FormList from '../form-list/FormList';
import FormPage from '../FormPage/FormPage';

import style from './Form.module.css';

type Store = {
    data: any
}

const FormCms = () => {
    const [initial, setInitial] = React.useState(true);

    const [form, setForm] = React.useState<any>({});
    const [page, setPage] = React.useState<number>(0);

    const [store, setStore] = React.useState<Store>({
        data: {
            custom: {}
        }
    });

    const [loading, setLoading] = React.useState(false);
    const [failed, setFailed] = React.useState(false);

    const getDataStore = (api: any, field: Field) => {
        if(field.custom) {
            return {
                put: (key: string, value: any) => {api.store.data.custom[key] = value},
                get: (key: string) => {return api.store.data.custom[key]}
            }
        }
        return {
            put: (key: string, value: any) => {api.store.data[key] = value;},
            get: (key: string) => {return api.store.data[key]}
        }
    }

    const api: any = {
        nextPage: () => {
            if (form.pages[page + 1].onLoad) {
                form.pages[page + 1].onLoad(api,
                    () => { setFailed(false); setPage(page + 1); },
                    () => { setFailed(true); }
                );
            } else {
                setPage(page + 1);
            }
        },
        previousPage: () => {
            if (form.pages[page - 1].onLoad) {
                form.pages[page - 1].onLoad(api,
                    () => { setFailed(false); setPage(page - 1); },
                    () => { setFailed(true); }
                );
            } else {
                setPage(page - 1);
            }
        },
        setPage: setPage,
        page: page,
        setForm: (pages: any) => { setForm(pages) },
        form: form,
        store: store,
        clearStore: () => { setStore({ data: { custom: {} } }) },
        putData: (key: string, value: any) => {store.data[key] = value},
        putCustomData: (key: string, value: any) => {store.data.custom[key] = value},
        getDataStore: (field: Field) => {return getDataStore(api, field)}
    };

    const load = (formId: any) => {
        setLoading(true);
        import('../../' + Config.namespace + '/pages/Pages').then((resolve: any) => {
            setForm(resolve.default[formId]);
            setFailed(false);
        }).catch((reject: any) => {
            setFailed(true);
            console.error(reject);
        }).finally(() => {
            setLoading(false);
        });
    }

    const currentPage = form.pages ? form.pages[page] : undefined;

    if (initial) {
        setInitial(false);
        load('unpacked_form_id'); // TO-DO: formId should come from url.
    }

    return (
        <FormPage api={api} loading={loading} page={currentPage} failed={false}></FormPage >
    )
};

export default FormCms;